import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import Component from '@plone/volto/components/theme/Component/Component';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImport } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { formatDate } from '../../../helpers'

const PubItemDate = ({ date }) => {
  const [formattedDate, setFormattedDate] = useState('');

  useEffect(() => {
    if (date) {
      setFormattedDate(formatDate(date));
    }
  }, [date]);

  return formattedDate && (
    <time className="pubItem__date" dateTime={date}> 
      {formattedDate}
    </time>
  );
};

const PublicationsListing = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}  className='pubList__readMore button ui inverted primary'>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href} className='pubList__readMore button ui inverted primary'>{linkTitle || href}</a>;
  }

  return (
    <>
      <ul className="pubList list-unstyled my-0">
        {items.map((item) => (
          <li key={item['@id']} className='pubList__item'>
            <article className="pubItem position-relative">

              {(item.image_field || item.image) &&
                <Component componentName="PreviewImage" item={item} alt="" className="pubItem__img" />
              }
              <div className="pubItem__text">
                <PubItemDate date={item.publicationtype_date} />
                <h3 className='pubItem__title'>

                 {!isEditMode ? (
                  <UniversalLink
                    href={`${flattenToAppURL(item['@id'])}/@@display-file/publication_document`}
                    className="pubItem__link stretched-link"
                    target="_blank"
                    rel="noopener noreferrer"
                    > {item.title} <span className="visually-hidden"><FormattedMessage id="Opens in new window" defaultMessage="Opens in new window" /></span>
                  </UniversalLink>
                  ): (
                    <span>{item.title}</span>
                  )}
                </h3>
                {item?.description &&
                  <p className='pubItem__desc'>{item.description}</p>
                }
                <span className="pubItem__readMore ">
                  <FontAwesomeIcon icon={faFileImport} />
                </span>
              </div>
            </article>
          </li>
        ))}
      </ul> 
    </>
  );
};

PublicationsListing.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default PublicationsListing;
